// src/pages/Admin/ProgramExplore.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';

function ProgramExplore() {
  const { id } = useParams();
  const [program, setProgram] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`/api/programs/${id}`)
      .then(response => {
        setProgram(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching program details.');
        setLoading(false);
      });
  }, [id]);

  const filteredModules = program && program.modules 
    ? program.modules.filter(module =>
        module.moduleName.toLowerCase().includes(search.toLowerCase()) ||
        module.moduleCode.toLowerCase().includes(search.toLowerCase()) ||
        (module.examType && module.examType.name && module.examType.name.toLowerCase().includes(search.toLowerCase())) ||
        (module.yearOfStudy && module.yearOfStudy.name && module.yearOfStudy.name.toLowerCase().includes(search.toLowerCase())) ||
        (module.semester && module.semester.name && module.semester.name.toLowerCase().includes(search.toLowerCase()))
      )
    : [];

  return (
    <div className="container mt-2">
      <TitleWithBack title="Explore Program" />
      {loading ? (
        <p>Loading program details...</p>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : (
        <>
          {/* Program Details */}
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <h2 className="card-title">{program.name}</h2>
              <p className="card-text"><strong>Code:</strong> {program.code}</p>
              {program.programCategory && (
                <p className="card-text"><strong>Category:</strong> {program.programCategory.name}</p>
              )}
            </div>
          </div>

          {/* Modules Section */}
          <div className="mb-3">
            <h4>Modules</h4>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Search modules by name, code, or exam type..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {program.modules && program.modules.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Module Name</th>
                    <th>Module Code</th>
                    <th>Exam Type</th>
                    <th>Year of Study</th>
                    <th>Semester</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredModules.map((module) => (
                    <tr key={module.id}>
                      <td>{module.moduleName}</td>
                      <td>{module.moduleCode}</td>
                      <td>{module.examType ? module.examType.name : 'N/A'}</td>
                      <td>{module.yearOfStudy ? module.yearOfStudy.name : 'N/A'}</td>
                      <td>{module.semester ? module.semester.name : 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>Nothing to show here</p>
          )}
        </>
      )}
    </div>
  );
}

export default ProgramExplore;
